/**
 * Hospedagem na Home (rodada 3, C9): o que se precisa ao chegar — nome,
 * endereço, "Como chegar" em um toque, check-in/out e as instruções (código
 * da porta, Wi-Fi). Tudo vem da viagem, que já está no aparelho: funciona
 * sem sinal. Sem hospedagem cadastrada, some — quem administra preenche em
 * Configurações da viagem.
 */
import { formatDayMonth, type CalendarDate } from '@nv/core';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import { usePermissao, useTrip } from '../../trip/TripContext';
import { Icon } from '../../ui/icons';
import { ComoChegar } from '../mapa/ComoChegar';

export function HospedagemNaHome() {
  const { trip } = useTrip();
  const podeEditar = usePermissao('manage_trip_settings');
  const [aberto, setAberto] = useState(false);
  if (!trip.accommodationName && !trip.accommodationAddress) return null;

  const periodo = [trip.accommodationCheckIn, trip.accommodationCheckOut]
    .map((d) => (d ? formatDayMonth(d as CalendarDate) : null))
    .filter(Boolean);
  const temDetalhe = !!trip.accommodationNotes || periodo.length > 0;

  return (
    <section className="card hosp" data-testid="home-hospedagem">
      <div className="hosp__cab">
        <span className="home-atalho__icone" aria-hidden="true">
          <Icon name="home" size={20} />
        </span>
        <span className="home-atalho__texto">
          <span className="home-atalho__titulo">{trip.accommodationName ?? 'Hospedagem'}</span>
          {trip.accommodationAddress && <span className="home-atalho__sub">{trip.accommodationAddress}</span>}
          {periodo.length > 0 && (
            <span className="home-atalho__sub" data-testid="hosp-periodo">
              {periodo.length === 2 ? `Check-in ${periodo[0]} · check-out ${periodo[1]}` : trip.accommodationCheckIn ? `Check-in ${periodo[0]}` : `Check-out ${periodo[0]}`}
            </span>
          )}
        </span>
        <ComoChegar
          destino={{ locationName: trip.accommodationAddress ?? trip.accommodationName ?? 'Hospedagem', placeId: trip.accommodationPlaceId, latitude: trip.accommodationLatitude, longitude: trip.accommodationLongitude }}
          className="nv-btn nv-btn--chip"
        >
          <Icon name="local" size={16} /> Como chegar
        </ComoChegar>
      </div>
      {temDetalhe && trip.accommodationNotes && (
        <>
          <button type="button" className="hosp__toggle" onClick={() => setAberto((v) => !v)} aria-expanded={aberto} data-testid="hosp-instrucoes-toggle">
            {aberto ? 'Esconder instruções' : 'Ver instruções'}
            <Icon name="avancar" size={14} />
          </button>
          {aberto && (
            <p className="hosp__notas" data-testid="hosp-instrucoes">
              {trip.accommodationNotes}
            </p>
          )}
        </>
      )}
      {!trip.accommodationNotes && podeEditar && (
        <Link to="/viagem/configuracoes" className="hosp__toggle">
          Pôr código da porta, Wi-Fi… <Icon name="avancar" size={14} />
        </Link>
      )}
    </section>
  );
}
